import {
  Box,
  Typography,
  styled,
  Skeleton,
  LinearProgress,
} from "@mui/material"
import { colors } from "../../theme/colors"
import { WhiteCard } from "../../components/styled"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
})

export const MoneyCounter = styled(Typography)({
  fontWeight: 400,
  textAlign: "center",
})

export const ButtonsContainer = styled(Box)({
  width: "100%",
  borderRadius: 20,
  display: "flex",
  justifyContent: "space-around",
  margin: "18px 0 20px 0",
  padding: "15px 39px",
  boxSizing: "border-box",
  backgroundColor: colors.yellow,
})

export const ButtonContainer = styled(Box)({
  width: 66,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  rowGap: 4,
})

export const MainButton = styled(Box)({
  width: 44,
  height: 44,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 50,
  backgroundColor: colors.white,
})

export const ButtonTitle = styled(Typography)({
  fontSize: 13,
  lineHeight: "15px",
  color: colors.lightBlack,
})

export const WhiteContainer = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  marginBottom: "20px",
})

export const CheckContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginTop: 20,
})

export const InfoContainer = styled(Box)({
  display: "flex",
})

export const Icon = styled(Box)({
  width: 46,
  height: 46,
  borderRadius: "40%",
  background: colors.lightGrey,
})

export const TitleContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginLeft: 14,
})

export const ExpensesWhiteCard = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
})

export const ExpensesContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
})

export const ExpensesProgress = styled(LinearProgress)({
  marginTop: 14,
  height: 5,
  borderRadius: 50,
  backgroundColor: colors.lightGrey,
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#E3697E",
  },
})

export const CapitalizeTypography = styled(Typography)({
  textTransform: "capitalize",
})

export const bankLinkingStyles = {
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
}

export const ChangeBank = {
  display: "contents",
}

export const SkeletonLoader = styled(Skeleton)({
  borderRadius: "12px",
})

export const ButtonStyle = {
  width: "50%",
  marginTop: "20px",
}
